<div class="d-flex align-items-center justify-content-between">
  <h4 class="title ms-2">Users</h4>
  <div class="d-flex align-items-center gap-2">
    <div class="search-bar">
      <mat-icon>search</mat-icon>
      <input type="text" [(ngModel)]="searchQuery" (input)="search()" placeholder="Search user by full name, phone, email or username"/>
    </div>
    <button class="filter-btn" [class.filter-btn--active]="isFilterActive" (click)="openFilterDialog()" title="Filter users">
      <mat-icon>filter_list</mat-icon>
      <span>Filter</span>
    </button>
  </div>
</div>
<div class="hashtags-container">
  <div class="hashtag-list-collection">
    <div class="hashtag-content-list">
      <div class="hashtag-info-text d-flex justify-content-between align-items-center">
        Users / {{ usersCount }}
        <div class="download-button m-3" (click)="downloadUsers()">
          <img src="assets/svg/download.svg" alt="">
        </div>
      </div>
      <div class="line-container-users"></div>
      <table class="tid-table">
        <tr>
          <th class="fixed-width-column">#</th>
          <th>Date</th>
          <th class="fixed-name-column">Full Name</th>
          <th>Phone</th>
          <th class="fixed-email-width-column">Email</th>
          <th>Ind Subsc.</th>
          <th>Promocode</th>
          <th>Team Subsc.</th>
          <th>Promocode</th>
          <th>Additional</th>
          <th class="fixed-width-column">Action</th>
        </tr>
        @if (users.length === 0 && isFilterActive) {
          <tr><td colspan="11" class="text-center py-3 text-muted">No users found matching these criteria</td></tr>
        }
        <ng-container *ngFor="let row of users; let index=index; let even=even">
          <tr class="tid-data-row cursor-pointer" (click)="row.showDetail = !row.showDetail"
              [ngClass]="{'tid-even': even}">
            <td>
              <div class="d-flex align-items-center" style="gap: 5px">
                @if (row.showDetail) {
                  <img src="assets/svg/arrow_drop_down.svg" alt="down svg">
                } @else {
                  <img src="assets/svg/arrow_drop_up.svg" alt="up svg">
                }
                {{ (userPage * userSize) + index + 1 }}
              </div>
            </td>
            <td>
              {{ row.createdDate | date: 'dd/MM/yyyy' }}
            </td>
            <td>
              <label for="forImage" class="pointer-custom col-sm-12 d-flex align-items-center">
                <div id="forImage" class="col-sm-12 text-center image-div">
                  <img [src]="row.profilePic ? userService.getImage(row.profilePic) : 'assets/svg/defaultUserIcon.svg'"
                       class="image-style" alt="">
                </div>
                <span class="ms-2"> {{ row.name + " " + row.surname }} </span>
              </label>
            </td>
            <td>
              {{ row.phoneNumber }}
            </td>
            <td>
              {{ row.email }}
            </td>
            <td>{{ (row.individualSubscription?.subscriptionInfo?.title) || "-" }}</td>
            <td>{{ (row.individualSubscription?.code || row.individualSubscription?.discount) ? (row.individualSubscription?.code + ' - ' + row.individualSubscription?.discount + "%") : '-' }}</td>
            <td>{{ (row.teamSubscription?.subscriptionInfo?.title) || "-" }}</td>
            <td>{{ (row.teamSubscription?.code || row.teamSubscription?.discount) ? (row.teamSubscription?.code + ' - ' + row.teamSubscription?.discount + "%") : '-' }}</td>
            <td>{{ row.additionalSubscription?.subscriptionInfo?.cardCount || "-" }}</td>
            <td>
              <div class="user-cards-subscription-type-container">
                <img src="assets/svg/delete.svg" alt="delete svg" (click)="openDeleteCardDialog(row)">
              </div>
            </td>
          </tr>
          <tr class="tid-detail-row"
              [ngClass]="{'show': row.showDetail}">
            <td colspan="10">
              <div>
                <div class="user-cards-inner-section">
                  <div class="user-cards-section-title">User's Cards</div>
                  <table class="user-cards-inner-table">
                    <thead>
                      <tr>
                        <th>Full Name</th>
                        <th>Username</th>
                        <th>Show QR</th>
                        <th>Card</th>
                        <th>Commission</th>
                        <th>Business</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (card of row.userCardsResponse; track card.userCardResponse.id) {
                        <tr>
                          <td>
                            <div class="inner-name-cell">
                              <img [src]="card.userCardResponse.profilePic
                                         ? userService.getImage(card.userCardResponse.profilePic)
                                         : 'assets/svg/defaultUserIcon.svg'"
                                   class="inner-avatar" alt="">
                              <span>{{ card.userCardResponse.name }} {{ card.userCardResponse.surname }}</span>
                            </div>
                          </td>
                          <td>
                            <div class="inner-username-cell">
                              <span class="inner-username">{{ card.userCardResponse.cardId }}</span>
                              <mat-icon class="inner-edit-icon"
                                        (click)="openEditUsernameDialog($event, card.userCardResponse)">edit</mat-icon>
                            </div>
                          </td>
                          <td>
                            <mat-icon class="inner-qr-icon"
                                      (click)="showQRCode($event, card.userCardResponse)">qr_code_2</mat-icon>
                          </td>
                          <td>{{ card.userCardResponse.hasTeam ? 'Team' : 'Individual' }}</td>
                          <td>
                            <select class="commission-template-select"
                                    [(ngModel)]="card.userCardResponse.commissionTemplateId"
                                    (ngModelChange)="onTemplateChange(card.userCardResponse, $event)">
                              @for (template of templates; track template.id) {
                                <option [ngValue]="template.id">{{ template.name }}</option>
                              }
                            </select>
                          </td>
                          <td>
                            <div class="switch" [ngClass]="{'active': card.userCardResponse.isBusiness}"
                                 (click)="toggleBusiness($event, card.userCardResponse, row.id)">
                              <div class="slider"></div>
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </table>
      <br>
    <div class="pagination">
      <a (click)="goToPage(userPage - 1)" [class.disabled]="userPage === 0">&laquo;</a>
      <a *ngFor="let page of getPageNumbers()"
         (click)="goToPage(page - 1)"
         [class.active]="userPage === (page - 1)">
        {{ page }}
      </a>
      <a (click)="goToPage(userPage + 1)" [class.disabled]="userPage === totalUsersPageCount - 1">&raquo;</a>
    </div>
  </div>
</div>
</div>

